import { Icon } from "@iconify-icon/react";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Axios, baseUrl } from "../Helpers/Axios";
import { AiOutlineLoading } from "react-icons/ai";
import { toast } from "react-toastify";
import Notifcation from "../Notification";
import { useContext } from "react";
import { CartCh } from "../../Context/CartContext";
import defaultImage from "../../images/juba.svg";
import { useTranslation } from "react-i18next";
const Cart = () => {
  const { t, i18n } = useTranslation();

  const [products, setProductus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [couponAmount, setCouponAmount] = useState(0);
  const cartch = useContext(CartCh);
  const setCartShopping = cartch.setCartChange;
  const cartShopping = cartch.cartChange;
  const [values, setValues] = useState();
  useEffect(() => {
    setLoading(true);
    Axios.get("/cart").then((data) => {
      console.log(data);
      setLoading(false);
      setProductus(Object.values(data.data.products));
      setValues(data.data);
    });
  }, [cartShopping]);
  const hanldeCheckOut = async () => {
    try {
      setLoading(true);
      if (values?.total !== "0.00 £") {
        Axios.post("/pay-via-paymob", {
          total: values.total,
        }).then((data) => {
          console.log(data);
          setLoading(false);

          window.location.href = data.data.link.order_url;
        });
      } else {
        Axios.post("/pay-via-free-gateway", {
          total: values.total,
        }).then((data) => {
          console.log(data);
          setLoading(false);

          toast.success(data.data.messege);
        });
      }
    } catch (err) {
      setLoading(false);
    }
  };
  // handleRemoveItem
  const handleRemoveItem = (id) => {
    setSpinner(id);
    try {
      Axios.get(`remove-cart-item/${id}`).then((data) => {
        //data);
        setCartShopping((prev) => !prev);
        toast.success(t("item deleted successfly"));
        setSpinner(false);
        setProductus(products.filter((data) => data.options.rowId != id));
      });
    } catch (err) {
      //err);
    }
  };
  // handleCoupon
  const handleCoupon = async () => {
    setLoading(true);

    try {
      Axios.post("/apply-coupon", { coupon: coupon }).then((data) => {
        setCouponAmount(data.data.discount_amount);
        setValues({ ...values, total: data.data.total });
        console.log(data);
        setLoading(false);

        toast.success(t(data.data.message));
      });
    } catch (err) {
      console.log(err);
      setLoading(false);

      toast.err(err.response.data.message);
      console.log(err.data.response.data.message);
    }
  };

  const nav = useNavigate();
  const [fav, setFav] = useState(false);
  return (
    <div className="flex gap-6 mt-6 md:flex-row flex-col justify-center items-center md:items-start md:justify-start">
      {loading && (
        <div className="fixed h-screen bg-white bg-opacity-50 z-50 inset-0 flex items-center justify-center">
          <div className="loader ease-linear rounded-full border-4 border-t-4 border-t-main border-gray-200 h-12 w-12 mb-4 animate-spin"></div>{" "}
        </div>
      )}
      <Notifcation />
      {/* Center */}
      <div className="flex-1">
        <div
          onClick={() => nav(-1)}
          className="flex items-center gap-2 cursor-pointer w-max"
        >
          <Icon
            className="text-text2"
            icon="formkit:arrowleft"
            width="24"
            height="24"
          />
          <span className="text-text2 text-base">{t("Back")}</span>
        </div>
        {/* Cards of  Courses */}
        <div className="flex items-center gap-3 mt-5 flex-wrap  justify-start">
          {/* Card */}
          {products?.length === 0 ? (
            <div className="flex justify-center p-6 w-full">
              <p className="text-center text-text2 font-bold text-base">
                {t("No items in Cart")}
              </p>
            </div>
          ) : (
            products?.map((item, index) => (
              <div
                key={index}
                className="w-[333px] min-w-[300px] rounded-lg overflow-hidden bg-white"
              >
                <div className="relative w-full h-[12.5rem] rounded-lg">
                  <img
                    src={`${baseUrl}/${item.options.image}`}
                    alt="course"
                    loading="lazy"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = defaultImage;
                    }}
                  />
                </div>
                <div className="p-4  ">
                  <p className="text-textColor text-[1.1rem]  ">{item.name}</p>
                  <div className="flex items-center justify-between mt-5">
                    <div className="flex items-center gap-3">
                      <div className="w-[2.2rem] h-[2.2rem] rounded-full overflow-hidden ">
                        <img
                          src={`${baseUrl}/${item.instructor.image}`}
                          alt="cart"
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <span className="text-textColor text-base">
                        {item.instructor.user_name}
                      </span>
                    </div>
                    <span className="text-base  text-main font-bold">
                      {item.price}
                    </span>
                  </div>
                  <button
                    onClick={() => handleRemoveItem(item.options.rowId)}
                    className="main-shadow duration-500 flex mt-4 justify-center items-center gap-2 text-white bg-main p-3 rounded w-full"
                  >
                    {spinner === item.options.rowId ? (
                      <AiOutlineLoading className="load-icon text-white" />
                    ) : (
                      <>
                        <Icon
                          icon="iconamoon:trash-light"
                          width="22"
                          height="22"
                        />
                        <span className="text-white ">{t("Remove")}</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        {/* Coupon */}
        {products.length !== 0 && (
          <div className="flex items-center gap-3 mt-5">
            <input
              type="text"
              onChange={(e) => setCoupon(e.target.value)}
              placeholder={t("Coupon code")}
              className="flex-1 px-6 bg-white py-2 border border-[#ddd] rounded-full outline-none focus:border-main"
            />
            <button
              onClick={handleCoupon}
              className="main-shadow whitespace-nowrap duration-500 text-base w-[30%] p-3 rounded-full bg-main text-white"
            >
              {t("Apply coupon")}
            </button>
          </div>
        )}
      </div>

      {/* Right Side */}
      <div className="w-[338px] h-max py-5 px-3 rounded bg-white border border-[#dddd]">
        <div className="text-center">
          <h3 className="text-textColor text-[1.15rem] py-3 border-b border-[#dddd]">
            {t("Cart total")}
          </h3>
        </div>
        <div className="py-6 border-b border-[#ddd flex justify-between items-center]">
          <span className="text-base text-textColor">{t("Total items")}</span>
          <span className="text-base text-textColor">{products?.length}</span>
        </div>
        <div className="py-6 border-b border-[#ddd flex justify-between items-center]">
          <span className="text-base text-textColor">{t("Discount")}</span>
          <span className="text-base text-textColor">{couponAmount}</span>
        </div>
        <div className="py-6 border-b border-[#ddd flex justify-between items-center]">
          <span className="text-base text-textColor">{t("Total")} </span>
          <span className="text-base text-textColor">{values?.total}</span>
        </div>
        <button
          disabled={products.length === 0}
          onClick={hanldeCheckOut}
          className={` inline-block text-center duration-500 mt-10 w-full p-3 text-base rounded text-white bg-main ${
            products.length === 0 &&
            "cursor-not-allowed bg-gray-600 hover:!shadow-none"
          }`}
        >
          {t("Checkout")}
        </button>
      </div>
    </div>
  );
};

export default Cart;
